import { useTranslation, Trans } from "next-i18next";
import parse from "html-react-parser";
import Testimonial from "../../components/v2/mw-carousel/testimonial";
import AgentIntegration from "../../components/v2/agent-integration";
import Accordion from "../../components/v2/accordion/accordion";
import ProductResources from "../../components/v2/product/product-resource";
import ProductHeroSection from "../../components/v2/common/product-hero";
import FeaturesMonitoring from "../../components/v2/tabs/features-monitoring";
import {Docker, K8s, Linux, Windows} from "../../components/v2/icons";
import '../../styles/scss/_faq-section.module.scss';

export default function Metrics() {
    const { t } = useTranslation("common");

    const featuresData = t('product.metrics.features.detailedFeatures', { returnObjects: true }) as any[]
    const features = Array.isArray(featuresData) ? featuresData : []

    const faqsData = t('product.metrics.faq.questions', { returnObjects: true }) as any[]
    const faqs = Array.isArray(faqsData) ? faqsData : []

    const resourceData = t('product.metrics.resources', { returnObjects: true }) as any[]
    const resource = Array.isArray(resourceData) ? resourceData : []

    const agentIntegrationData = t('product.metrics.agentIntegration', { returnObjects: true }) as any

    const agentDeployData = t('product.shared.agentDeploy', { returnObjects: true }) as any[]
    const agentDeployArray = Array.isArray(agentDeployData) ? agentDeployData : []

    const agentDeploy = agentDeployArray.map(agent => ({
        ...agent,
        icon: agent.key === 'kubernetes' ? <K8s/> :
              agent.key === 'linux' ? <Linux/> :
              agent.key === 'docker' ? <Docker/> :
              agent.key === 'windows' ? <Windows/> :
              <span className={"text-gradient"}>450+</span>
    }))

    return (
        <>
            <ProductHeroSection title={<h1><span className="text-gradient">{t('product.metrics.hero.title')}</span></h1>}
                                description={t('product.metrics.hero.description')}
                                img={"/images/product/metrics-product.png"} imgMobile={"/images/product/metrics-product-mobile.webp"} imgAlt={t('product.metrics.hero.imageAlt')} preloadImg hasActions={true} className={"metrics-page"} tips={t('product.hero.tips')}/>


            <FeaturesMonitoring productFeatures={features} title={<h2>{t('product.metrics.section.title')}</h2>} tourId={""} className={"metric-page"}/>

            <Testimonial/>

            <AgentIntegration agentDeploy={agentDeploy} title={<h2><Trans
                                        i18nKey="product.metrics.agentIntegration.title"
                                        components={{
                                            highlight: <span className="text-gradient" />
                                        }}
                                    /></h2>} description={agentIntegrationData.description}/>

            <ProductResources resources={resource} title={t('product.shared.resources.title')}/>

            <section className={"faq-section"}>
                <div className={"container"}>
                    <h2>{t('product.metrics.faq.title')}</h2>
                    <p>{t('product.metrics.faq.subtitle')}</p>
                    <div className={"faq-item"}>
                        <Accordion faqs={faqs.map(faq => ({
                            ...faq,
                            answerPlain: faq.text,
                            text:
                                faq.textHtml != null && faq.textHtml !== ""
                                    ? parse(faq.textHtml)
                                    : <p>{faq.text}</p>
                        }))} showGroups={true}/>
                    </div>
                </div>
            </section>

        </>
    )
}